// src/pages/SettingsPage/utils/settings.utils.ts
export const formatDate: (config: { timestamp: number }) => string = ({
  timestamp,
}) => new Date(timestamp * 1000).toLocaleDateString();
